'use client'

import React, { FC, PropsWithChildren, ReactNode } from 'react'
import styles from './PageSection.module.css'
import classNames from 'classnames'
import useWindowSize from '@/utils/hooks/useWindowSize'

const PageSection: FC<
	PropsWithChildren<{
		title?: string
		titleClassName?: string
		description?: string
		descriptionClassName?: string
		className?: string
		headerClassName?: string
		contentClassName?: string
		headerContent?: ReactNode
	}>
> = (props) => {
	const { title, description, descriptionClassName: _descriptionClassName, className, headerClassName, contentClassName } =
		props
	const { isMobile } = useWindowSize()
	return (
		<div className={classNames({ [props.className ?? '']: !!className }, styles.root)}>
			<div className={classNames({ [headerClassName ?? '']: !!headerClassName }, styles.left)}>
				<p
					className={classNames(styles.title, 'display-md', 'bold', {
						[props.titleClassName ?? '']: !!props?.titleClassName
					})}
				>
					{title}
				</p>
				<p
					className={classNames(styles.description, isMobile ? 'text-md' : 'text-xl', 'semibold', {
						[props.descriptionClassName ?? '']: !!props?.descriptionClassName
					})}
				>
					{description}
				</p>
				{props?.headerContent}
			</div>
			<div className={classNames({ [props.contentClassName ?? '']: !!contentClassName }, styles.right)}>
				{props.children}
			</div>
		</div>
	)
}

export default PageSection
